// import React, { useContext, useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Box, Spinner, Text, Image, Button, Flex } from '@chakra-ui/react';
// import DepositContext from './DepositContext';

// const DepositDetails = () => {
//   const { id } = useParams();
//   console.log(id)
//   const navigate = useNavigate();
//   const { deposits, deleteDeposit,fetchDepositById, updateDeposit, filterStatus,updateDepositregected } = useContext(DepositContext);
// console.log(deposits)
//  console.log(deposits)
//   const [deposit, setDeposit] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       const data = await fetchDepositById(id);  // Use fetchDepositonly here
//       setDeposit(data);
//     };
//     fetchData();
//   }, [id, fetchDepositById]);

//   if (!deposit) {
//     return <Spinner />;
//   }

//   const handleApprove = () => {
//     if (window.confirm('Are you sure you want to approve this deposit?')) {
//       updateDeposit(id, 'approved');
//       navigate('/dashboard/admin/deposits');
//     }
//   };

//   const handleReject = () => {
//     if (window.confirm('Are you sure you want to reject this deposit?')) {
//       updateDepositRejected(id, 'rejected');
//       navigate('/dashboard/admin/deposits');
//     }
//   };

//   const handleDelete = () => {
//     if (window.confirm('Are you sure you want to delete this deposit?')) {
//       deleteDeposit(id);
//       navigate('/dashboard/admin/deposits');
//     }
//   };

//   return (
//     <Box>
//       <Text fontSize="2xl" mb={4}>Deposit Details</Text>
//       <Flex>
//         <Image boxSize="100px" src={`http://localhost:9000/${deposit.item.coverphoto.path}`} alt={deposit.item.name} />
//         <Box ml={4}>
//           <Text>Name: {deposit.item.name}</Text>
//           <Text>Amount: {deposit.amount}</Text>
//           <Text>Status: {deposit.status}</Text>
//           <Text>User: {deposit.userId.name}</Text>
//           <Text>Billing Method: {deposit.billingmethod}</Text>
//         </Box>
//       </Flex>
//       <Flex mt={4}>
//         <Button colorScheme="green" onClick={handleApprove} mr={2}>Approve</Button>
//         <Button colorScheme="yellow" onClick={handleReject} mr={2}>Reject</Button>
//         <Button colorScheme="red" onClick={handleDelete}>Delete</Button>
//       </Flex>
//     </Box>
//   );
// };

// export default DepositDetails;



// import React, { useState } from 'react';
// import { useNavigate,useParams } from 'react-router-dom';
// import { Box, Spinner, Text, Image, Button, Flex, Alert, AlertIcon } from '@chakra-ui/react';
// import { useQuery,queryClient, useMutation } from 'react-query';

// import DepositService from './DepositService';

// const DepositDetails = () => {
//   const navigate = useNavigate();
//   const [deposit, setDeposit] = useState(null);
//   const [setAlert, alert] = useState(false);
//   const { id } = useParams();
// console.log(id)

//   const { data: depositData, isLoading } = useQuery(['deposit', id], async () => {
//     const { data } = await DepositService.fetchDepositById(id);
//     console.log(data?.data?.data)
//     setDeposit(data?.data?.data);
//     return data;
//   });

//   const mutationUpdate = useMutation(async (newStatus) => {
//     await DepositService.updateDeposit(id, { status: newStatus });
//     // Refetch deposit after update
//     // await queryClient.invalidateQueries(['deposit', id]);
//   });

//   const mutationDelete = useMutation(async () => {
//     await DepositService.deleteDeposit(id);
//     navigate('/dashboard/admin/deposits');
//   });

//   const handleApprove = async () => {
//     if (window.confirm('Are you sure you want to approve this deposit?')) {
//       await mutationUpdate.mutateAsync('approved');
//       showAlert('success', 'Deposit approved successfully!');
//     }
//   };

//   const handleReject = async () => {
//     if (window.confirm('Are you sure you want to reject this deposit?')) {
//       await mutationUpdate.mutateAsync('rejected');
//       showAlert('success', 'Deposit rejected successfully!');
//     }
//   };

//   const handleDelete = async () => {
//     if (window.confirm('Are you sure you want to delete this deposit?')) {
//       await mutationDelete.mutateAsync();
//       showAlert('success', 'Deposit deleted successfully!');
//     }
//   };

//   const showAlert = (status, message) => {
//     setAlert({ status, message });
//     setTimeout(() => {
//       setAlert(null);
//     }, 5000);
//   };
// console.log(depositData)
//   return (
//     <Box>
//       <Text fontSize="2xl" mb={4}>Deposit Details</Text>
//       {isLoading && <Spinner />}
//       {depositData && (
//         <>
//           <Flex>
//             <Image boxSize="100px" src={`http://localhost:9000/${depositData?.data?.data?.item.coverphoto.path}`} alt={depositData?.data?.data?.item.name} />
//             <Box ml={4}>
//               <Text>Name: {depositData?.data?.data?.item.name}</Text>
//               <Text>Amount: {depositData?.data?.data?.amount}</Text>
//               <Text>Status: {depositData?.data?.data?.status}</Text>
//               <Text>User: {depositData?.data?.data?.userId.name}</Text>
//               <Text>Billing Method: {depositData?.data?.data?.billingmethod}</Text>
//             </Box>
//           </Flex>
//           <Flex mt={4}>
//             <Button colorScheme="green" onClick={handleApprove} mr={2}>Approve</Button>
//             <Button colorScheme="yellow" onClick={handleReject} mr={2}>Reject</Button>
//             <Button colorScheme="red" onClick={handleDelete}>Delete</Button>
//           </Flex>
//         </>
//       )}
//       {alert && (
//         <Alert status={alert.status} mt={4}>
//           <AlertIcon />
//           {alert.message}
//         </Alert>
//       )}
//     </Box>
//   );
// };

// export default DepositDetails;
import React, { useState } from 'react';
import { Box, Button, Spinner, Image, Flex, Text, Alert, AlertIcon } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery, useMutation } from 'react-query';
import DepositService from './DepositService';
import Api from '../../../api/ApiUrl'

const DepositDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [alert, setAlert] = useState(null);

  const { data: depositData, isLoading } = useQuery(['deposit', id], async () => {
    const { data } = await DepositService.fetchDepositById(id);
    return data;
  });

  const mutationUpdate = useMutation(async (newStatus) => {
    await DepositService.updateDeposit(id, { status: newStatus });
  });
  const mutatioregect= useMutation(async (newStatus) => {
    await DepositService.updateDepositregected(id, { status: newStatus });
  })

  const mutationDelete = useMutation(async () => {
    await DepositService.deleteDeposit(id);
    navigate('/dashboard/admin/deposit');
  });

  const handleApprove = async () => {
    if (window.confirm('Are you sure you want to approve this deposit?')) {
      await mutationUpdate.mutateAsync('approved');
      showAlert('success', 'Deposit approved successfully!');
    navigate('/dashboard/admin/deposit');

    }
  };

  const handleReject = async () => {
    if (window.confirm('Are you sure you want to reject this deposit?')) {
      await mutatioregect.mutateAsync('rejected');
      showAlert('success', 'Deposit rejected successfully!');
    navigate('/dashboard/admin/deposit');

    }
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this deposit?')) {
      await mutationDelete.mutateAsync();
      showAlert('success', 'Deposit deleted successfully!');
    navigate('/dashboard/admin/deposit');

    }
  };

  const showAlert = (status, message) => {
    setAlert({ status, message });
    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  return (
    <Box>
      <Text fontSize="2xl" mb={4}>Deposit Details</Text>
      {isLoading && <Spinner />}
      {depositData && (
        <>
          <Flex>
            <Image boxSize="100px" src={`${Api}/${depositData?.data?.data?.billImage?.path}`} alt={depositData?.data?.data?.item.name} />
            <Box ml={4}>
              <Text>Name: {depositData?.data?.data?.item.name}</Text>
              <Text>Amount: {depositData?.data?.data?.amount}</Text>
              <Text>Status: {depositData?.data?.data?.status}</Text>
              <Text>User: {depositData?.data?.data?.userId.name}</Text>
              <Text>Billing Method: {depositData?.data?.data?.billingmethod}</Text>
            </Box>
          </Flex>
          <Flex mt={4}>
            <Button colorScheme="green" onClick={handleApprove} mr={2}>Approve</Button>
            <Button colorScheme="yellow" onClick={handleReject} mr={2}>Reject</Button>
            <Button colorScheme="red" onClick={handleDelete}>Delete</Button>
          </Flex>
        </>
      )}
      {alert && (
        <Alert status={alert.status} mt={4}>
          <AlertIcon />
          {alert.message}
        </Alert>
      )}
    </Box>
  );
};

export default DepositDetails;
